/* OL SUPPORT-CHAT - Maschine
 *
 * WARUM OHNE KI-SERVER: ein Sprachmodell im Browser braucht einen
 * Schluessel, und ein Schluessel im Theme ist ein oeffentlicher
 * Schluessel. Ein eigener Server dafuer waere ein zweites System mit
 * eigenen Kosten und eigenen Ausfaellen. Was die Kunden hier wirklich
 * fragen, sind rund zwei Dutzend immer gleiche Dinge - Schluessel
 * nicht angekommen, 0xC004C003, Retail oder Volumen, Umzug auf einen
 * neuen PC. Dafuer braucht es kein Modell, dafuer braucht es die
 * richtigen Antworten und ein Suchverfahren, das Tippfehler und
 * Umschreibungen ueberlebt.
 *
 * DAS VERFAHREN
 * 1. Fehlercodes zuerst. "0xc004c003" ist eindeutig; wer einen Code
 *    nennt, will die Antwort zu diesem Code und nichts anderes.
 * 2. Danach Wortabgleich. Die Frage wird entschaerft (Kleinschrift,
 *    Akzente weg, Satzzeichen weg) und in Woerter zerlegt. Jedes
 *    Stichwort eines Eintrags, das vorkommt, zaehlt - laengere
 *    Stichwoerter zaehlen mehr, weil "aktivierungsassistent" mehr
 *    aussagt als "pc".
 * 3. Tippfehler: wer sich um einen Buchstaben vertippt, bekommt
 *    trotzdem einen Treffer (Abstand 1 bei Woertern ab fuenf Zeichen).
 * 4. Unter der Schwelle wird NICHT geraten. Dann zeigt die Maschine
 *    die drei naechstliegenden Themen und den Weg zum Menschen. Eine
 *    falsche Antwort mit Selbstbewusstsein ist schlimmer als keine.
 *
 * Das Wissen steht nicht hier, sondern in ol-hilfe-<sprache>.js.
 * Geladen wird nur die Sprache der Seite.
 */
(function () {
  'use strict';

  function entschaerfe(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[ß]/g, 'ss')
      .replace(/[^a-z0-9ıçğöşüąćęłńóśźżæøå\s]/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* Abstand 1 reicht: mehr Toleranz holt Fremdes herein. */
  function fastGleich(a, b) {
    if (a === b) return true;
    if (a.length < 5 || Math.abs(a.length - b.length) > 1) return false;
    var i = 0, j = 0, fehler = 0;
    while (i < a.length && j < b.length) {
      if (a[i] === b[j]) { i++; j++; continue; }
      if (++fehler > 1) return false;
      if (a.length > b.length) i++;
      else if (a.length < b.length) j++;
      else { i++; j++; }
    }
    return true;
  }

  function codes(s) {
    var m = (s || '').toLowerCase().match(/0x[0-9a-f]{4,10}/g);
    return m || [];
  }

  /* Wie oft kommt ein Stichwort in der ganzen Sammlung vor? Ein Wort,
     das in fuenf Eintraegen steht, sagt fast nichts; ein Wort, das nur
     in einem steht, sagt alles. "server" steht bei Windows Server UND
     beim KMS-Fehler, "kms" nur beim KMS-Fehler - ohne diese Gewichtung
     gewinnt bei "kms server nicht erreichbar" das falsche Thema. */
  var haeufig = null;
  function zaehle(wissen) {
    haeufig = {};
    for (var i = 0; i < wissen.length; i++) {
      var gesehen = {};
      for (var j = 0; j < wissen[i].f.length; j++) {
        var k = entschaerfe(wissen[i].f[j]);
        if (!k || gesehen[k]) continue;
        gesehen[k] = 1;
        haeufig[k] = (haeufig[k] || 0) + 1;
      }
    }
  }
  function gewicht(stich) {
    var n = (haeufig && haeufig[stich]) || 1;
    if (n === 1) return 2.5;
    return 1 / n;
  }

  function bewerte(frage, eintrag) {
    var punkte = 0;
    var roh = (frage || '').toLowerCase();
    var text = entschaerfe(frage);
    var woerter = text.split(' ').filter(Boolean);

    /* Eindeutige Marken zuerst: Fehlercodes, aber auch Fachwoerter wie
       kms, ospp, cal. Wer "kms" schreibt, meint den KMS-Fehler und
       nicht das Produkt Windows Server, auch wenn dort "server" steht
       und "server" das laengere Wort ist. Solche Marken stehen im Feld
       c und sind sprachunabhaengig. */
    if (eintrag.c && eintrag.c.length) {
      var marken = codes(roh).concat(woerter);
      for (var h = 0; h < eintrag.c.length; h++) {
        var marke = eintrag.c[h].toLowerCase();
        for (var g = 0; g < marken.length; g++) {
          if (marken[g] === marke) return 1000;
        }
      }
    }

    for (var i = 0; i < eintrag.f.length; i++) {
      var stich = entschaerfe(eintrag.f[i]);
      if (!stich) continue;
      var g = gewicht(stich);
      if (stich.indexOf(' ') > -1) {
        /* Eine ganze Wendung im Text ist immer ein starkes Zeichen und
           wird nicht heruntergewichtet. */
        if (text.indexOf(stich) > -1) punkte += stich.length * 2;
        continue;
      }
      for (var j = 0; j < woerter.length; j++) {
        if (woerter[j] === stich) { punkte += stich.length * 2 * g; break; }
        if (stich.length > 4 && woerter[j].indexOf(stich) === 0) { punkte += stich.length * g; break; }
        /* auch andersherum: wer "herunter" tippt, meint "herunterladen" */
        if (woerter[j].length > 4 && stich.indexOf(woerter[j]) === 0) { punkte += woerter[j].length * g; break; }
        if (fastGleich(woerter[j], stich)) { punkte += stich.length * 0.8 * g; break; }
      }
    }
    return Math.round(punkte);
  }

  function suche(frage, wissen) {
    if (!haeufig) zaehle(wissen);
    var liste = [];
    for (var i = 0; i < wissen.length; i++) {
      var p = bewerte(frage, wissen[i]);
      if (p > 0) liste.push({ e: wissen[i], p: p });
    }
    liste.sort(function (a, b) { return b.p - a.p; });
    return liste;
  }

  /* Die Schwelle waechst mit der Laenge der Frage: bei einem einzigen
     Wort genuegt ein guter Treffer, bei einem ganzen Satz muss mehr
     zusammenpassen, sonst gewinnt ein Allerweltswort. */
  function schwelle(frage) {
    var n = entschaerfe(frage).split(' ').filter(Boolean).length;
    if (n <= 2) return 8;
    if (n <= 5) return 11;
    return 14;
  }

  window.olHilfe = {
    entschaerfe: entschaerfe,
    suche: suche,
    schwelle: schwelle,
    neuZaehlen: function () { haeufig = null; },
    antworte: function (frage, wissen) {
      var liste = suche(frage, wissen || []);
      if (!liste.length) return { art: 'nichts', vorschlaege: (wissen || []).slice(0, 3) };
      if (liste[0].p >= schwelle(frage)) {
        var weitere = [];
        for (var i = 1; i < liste.length && weitere.length < 2; i++) {
          if (liste[i].p >= schwelle(frage) * 0.55) weitere.push(liste[i].e);
        }
        return { art: 'treffer', eintrag: liste[0].e, weitere: weitere };
      }
      return {
        art: 'unsicher',
        vorschlaege: liste.slice(0, 3).map(function (x) { return x.e; })
      };
    }
  };
})();
